var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataforms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M276.068,511.221c110.004-8.53,200.501-86.59,227.612-190.285L361.624,178.879L242.497,311.453 l47.83,47.83L154.629,389.78L276.068,511.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7248BD"
    },
    d: "M296.439,113.693H171.613c-11.729,0-21.237,9.509-21.237,21.237v242.14 c0,11.729,9.509,21.237,21.237,21.237h168.774c11.729,0,21.237-9.509,21.237-21.237V178.878L296.439,113.693z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 233.382,
    y: 248.467,
    style: {
      fill: "#FFFFFF"
    },
    width: 84.747,
    height: 10.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.382,
    y: 277.98,
    style: {
      fill: "#FFFFFF"
    },
    width: 84.747,
    height: 10.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.382,
    y: 307.493,
    style: {
      fill: "#FFFFFF"
    },
    width: 84.747,
    height: 10.261
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.64,258.732h-4.175c-2.108,0-3.817-1.708-3.817-3.817v-2.627c0-2.108,1.708-3.817,3.817-3.817 h4.175c2.108,0,3.817,1.708,3.817,3.817v2.627C208.456,257.024,206.748,258.732,204.64,258.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.64,288.242h-4.175c-2.108,0-3.817-1.708-3.817-3.817v-2.627c0-2.108,1.708-3.817,3.817-3.817 h4.175c2.108,0,3.817,1.708,3.817,3.817v2.627C208.456,286.532,206.748,288.242,204.64,288.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.64,317.75h-4.175c-2.108,0-3.817-1.708-3.817-3.817v-2.627c0-2.108,1.708-3.817,3.817-3.817 h4.175c2.108,0,3.817,1.708,3.817,3.817v2.627C208.456,316.042,206.748,317.75,204.64,317.75z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8A3DE"
    },
    d: "M317.676,178.878h43.948l-65.184-65.184v43.948C296.439,169.37,305.947,178.878,317.676,178.878z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataforms);
export default __webpack_public_path__ + "static/media/dataforms.7101b64c8b918e9731069053cd8a0426.svg";
export { ForwardRef as ReactComponent };